import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Logo } from "@/components/site/Logo";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const login = (path) => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + (path || window.location.pathname);
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* sessione già chiusa */
    }
    setUser(null);
    toast("Sei uscito. A presto!");
  };

  return <AuthCtx.Provider value={{ user, setUser, loading, login, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const run = async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sid });
        setUser(data);
        toast.success(`Ciao ${data?.name?.split(" ")[0] || ""}! Accesso effettuato.`);
      } catch {
        toast.error("Accesso non riuscito. Riprova.");
      }
      navigate(location.pathname, { replace: true });
    };
    run();
  }, [location.hash, location.pathname, navigate, setUser]);

  return (
    <div className="grid min-h-screen place-items-center" data-testid="auth-callback">
      <Logo className="animate-pulse" />
    </div>
  );
};
